appSocial.service('TradeAggregated', ['SocialConstants', function (SocialConstants) {
    /**
     * @name TradeAggregated
     * @class
     */
    class TradeAggregated {
        constructor(
            /**
             * @type {Trader}
             */
            trader,
            data = {}) {

            this.constants = SocialConstants;

            this.symbol = data.symbol;
            this.count = data.count;
            this.countPercentage = trader.tradesCount === 0 ? 0 : (this.count * 100) / trader.tradesCount;
            this.avgProfit = data.avg_profit;
            this.avgWinProfit = data.avg_win_profit;
            this.avgLossProfit = data.avg_loss_profit;
            this.market = data.market;

            // flags
            if (this.market === 'Crypto' || this.market === 'Currencies') {
                this.nameLeft = data.symbol.replace('/', '').slice(0, 3).toLowerCase();
                this.nameRight = data.symbol.replace('/', '').slice(3, 6).toLowerCase();
                const flagClass = 'flag-icon-';
                this.flagLeft = flagClass + this.getAssetCountry(this.nameLeft);
                this.flagRight = flagClass + this.getAssetCountry(this.nameRight);
            } else {
                this.flagFallback = 'todo';
            }
        }


        getAssetCountry(assetName) {
            return this.constants.symbols.symbolSubst.hasOwnProperty(assetName)
                ? this.constants.symbols.symbolSubst[assetName]
                : assetName;
        }
    }
    return TradeAggregated;
}])
